export default "__VITE_ASSET__a4ba93b5__"